import { render } from "./ImportModal.vue?vue&type=template&id=44d51ed2&scoped=true&ts=true"
import script from "./ImportModal.vue?vue&type=script&lang=ts"
export * from "./ImportModal.vue?vue&type=script&lang=ts"

import "./ImportModal.vue?vue&type=style&index=0&id=44d51ed2&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-pim-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d51ed2"]])

export default __exports__